import React from "react";
import * as S from './InfoListCardMmtStyles'
import { HOB_CHEVRON_RIGHT } from "../../../../../config/constants";

const InfoListCardMmt = ({
    title,
    ctaClickHandler,
    ctaText,
    data
}) => {

  const formatTextWithBold = (text)=> {
    const boldRegex = /\*([^*]+)\*/g;
    return text.split(boldRegex).map((part, index) => {
      if (index % 2 === 0) {
        return part;
      } else {
        return <strong key={index}>{part}</strong>;
      }
    });
  }

  return (
    <S.InclusionsContainer>
      <S.InclusionHeading>{title}</S.InclusionHeading>
      <S.InfoListCard>
        {data && (
          <S.ListItems>
            {data?.map((item, idx) => (
              <S.ListItem>
                <S.Status src={item?.icon} />
                <S.Label>
                  {formatTextWithBold(item?.text)}
                </S.Label>
              </S.ListItem>
            ))}
          </S.ListItems>
        )}
        {ctaText && (
          <>
            <S.Separator />
            <S.CtaSection onClick={ctaClickHandler}>
              <S.CtaLabel>{formatTextWithBold(ctaText)}</S.CtaLabel>
              <S.ArrowIcon
                src={HOB_CHEVRON_RIGHT}
                alt="arrow"
              />
            </S.CtaSection>
          </>
        )}
      </S.InfoListCard>
    </S.InclusionsContainer>
  );
};

export default InfoListCardMmt;